import React, { useState } from 'react';
import Modal from 'react-modal';
import Input from '../../TravellerContactInfo/FormFields/Input';
import '../LoginModals.css';
import { If } from 'react-extras';
import {customStyles, UserFlowModalState} from '../../UserFlow/UserFlowModal';

const initialStates = {
  showModal: true,
  validationFail: false,
};

const UsernameDeactivated = (props: UserFlowModalState) => {
  const [ state, setState ] = useState(initialStates);

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const goToIRCTCRegistrationPage=() => {
    props.createAccount();
  };

  const { userStatus: { userId }, switchModal, allowClose } = props;
  const { showModal, validationFail } = state;
  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <p className="makeFlex spaceBetween appendBottom40">
        <span className="modalTitle font26 latoBloack blackText">
            Username Deactivated
        </span>
        <If condition={allowClose === true}>
          <span
            className="modalClose railSprite crossIcon"
            onClick={closeModal}
          />
        </If>
      </p>
      <p className="vrtlSeperater" />
      <div className="makeFlex spaceBetween">
        <div className="leftPanel">
          <p className="font20 latoBold darkGreyText appendBottom10"> Why Verify? </p>
          <p className="font14 darkGreyText appendBottom40">
            <span className="yellowText"> This is a compulsory step</span> required by IRCTC to ensure that your booking does not fail after payment.
          </p>
          <div className={`makeFlex appendBottom40 spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="IRCTC Username"
              errorMessage={`Username ${userId} doesn’t exist.`}
              validationFail={validationFail}
              type="text"
              additionalAttributes={{ placeholder: userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg=""
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly
              irctcUserId={userId}
              switchModal={switchModal}
              onChangePage="verifyUsername"
            />
          </div>
          <p className="font14">
              Please email <a className="latoBold" href="mailto:care@irctc.co.in?Subject=Need%20help" target="_top">care@irctc.co.in</a> for further assistance. <br /> You can also create a new IRCTC account.
          </p>
        </div>
        <div className="rightPanel">
          <p className="font20 latoBold darkGreyText appendBottom10">Create New Account</p>
          <p className="font14 appendBottom40">
            <span className="yellowText">Register with IRCTC</span> for a new username and password with a different email address and mobile number.
          </p>
          <button
            className="rightPanelBtn latoBold font12 deepskyBlueText appendBottom60 textCenter"
            onClick={goToIRCTCRegistrationPage}
          >
              Create New Account
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UsernameDeactivated;
